module.exports = __webpack_public_path__ + "img/strand.a66e06ca.png";